// Remembers the sort chosen on the Template List page, per user, in this browser (localStorage), so the list opens
// the way the user left it instead of always "Template Name · A–Z". Storage can be blocked (private mode, cleared
// site data), so every read and write is wrapped and the page falls back to the default.
const KEY_PREFIX = 'eauditor.templateList.sortBy'

// Same keys as TEMPLATE_SORT_OPTIONS in page-components/template-list/List.js (and the API's SortBy whitelist).
export const TEMPLATE_SORT_KEYS = ['name', 'name_desc', 'created_desc', 'created_asc']
export const DEFAULT_TEMPLATE_SORT = 'name'

const keyFor = userId => `${KEY_PREFIX}.${userId || 0}`

/** The saved sort for this user, or the default when nothing (valid) is saved. */
export const getSavedTemplateSort = (userId, fallback = DEFAULT_TEMPLATE_SORT) => {
    try {
        const value = window.localStorage.getItem(keyFor(userId))
        return TEMPLATE_SORT_KEYS.includes(value) ? value : fallback
    } catch (error) {
        return fallback
    }
}

/** Saves the sort for this user; unknown values are ignored. */
export const saveTemplateSort = (userId, value) => {
    if (!TEMPLATE_SORT_KEYS.includes(value)) return
    try {
        window.localStorage.setItem(keyFor(userId), value)
    } catch (error) {
        // storage unavailable: the choice just won't be remembered
    }
}
